import type { Asset, AssetId, AssetSet } from "./Asset";
import type { URLProvidingEffectClass } from "./AudioEffect";
import type { PlaylistClip } from "./Clip";

export enum AssetUrlType {
  AUDIO = "AUDIO",
  VIDEO_360p = "VIDEO_360p",
}

export interface IAssetUrlCache {
  setAssets(assets: AssetSet): void;

  getAsset(assetId: AssetId): Asset;

  getClipUrl(
    clip: PlaylistClip,
    urlProvider: URLProvidingEffectClass,
    type: AssetUrlType
  ): Promise<string>;

  invalidateClipUrl(
    clip: PlaylistClip,
    urlProvider: URLProvidingEffectClass,
    type: AssetUrlType
  ): void;

  addLocalAsset(assetId: AssetId, blob: Blob): void;

  hasLocalAsset(clip: PlaylistClip): boolean;

  // there is a race condition with clips + assets being added to the state
  // vs the audio blob being handed off to the streaming player
  // if we have an asset without a url and no blob url, we should wait for the blob url to be handed off
  canLoadClip(clip: PlaylistClip): boolean;

  reset(): void;
}
